<template>
  <div class="main-layout">
    <!-- Sidebar -->
    <AppSidebar v-model="sidebarOpen" />

    <!-- Contenedor principal -->
    <div class="main-container" :class="{ 'sidebar-collapsed': !sidebarOpen }">
      <!-- Top Bar -->
      <AppHeader :sidebar-open="sidebarOpen" @toggle-sidebar="sidebarOpen = !sidebarOpen" />

      <!-- Contenido -->
      <div class="main-content">
        <div class="content-wrapper">
          <slot />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref } from 'vue'
import AppSidebar from './AppSidebar.vue'
import AppHeader from './AppHeader.vue'

export default {
  name: 'MainLayout',
  components: {
    AppSidebar,
    AppHeader
  },
  setup() {
    const sidebarOpen = ref(true)

    return {
      sidebarOpen
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  min-height: 100vh;
  background-color: #F8FAFC;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 240px;
  transition: margin-left 0.3s ease, width 0.3s ease;
  height: 100vh;
  overflow: hidden;
  width: calc(100% - 240px);
  min-width: 0;
}

.main-container.sidebar-collapsed {
  margin-left: 0;
  width: 100%;
}

.main-content {
  flex: 1;
  background-color: #F8FAFC;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  height: 0; /* Forzar que el contenedor respete el flex y permita scroll */
}

.content-wrapper {
  padding: 20px 24px 16px 24px;
  min-height: 100%;
}

@media (max-width: 960px) {
  .main-container {
    margin-left: 0;
  }

  .content-wrapper {
    padding: 12px 16px;
  }
}
</style>

<!-- Estilos globales para Dark Mode - Paleta Slate Moderna -->
<style>
/* Dark mode: Fondo oscuro para el layout principal */
.v-theme--dark .main-layout,
.v-theme--darkTheme .main-layout {
  background-color: #0F172A;
}

.v-theme--dark .main-content,
.v-theme--darkTheme .main-content {
  background-color: #0F172A;
}

/* Dark mode: Asegurar que el texto en el contenido sea legible */
.v-theme--dark .content-wrapper,
.v-theme--darkTheme .content-wrapper {
  color: #E0E0E0;
}

/* Dark mode: Títulos y subtítulos */
.v-theme--dark .content-wrapper h1,
.v-theme--dark .content-wrapper h2,
.v-theme--dark .content-wrapper h3,
.v-theme--darkTheme .content-wrapper h1,
.v-theme--darkTheme .content-wrapper h2,
.v-theme--darkTheme .content-wrapper h3 {
  color: #FFFFFF;
}

/* Dark mode: Texto secundario */
.v-theme--dark .content-wrapper .text-grey,
.v-theme--darkTheme .content-wrapper .text-grey {
  color: #BDBDBD !important;
}
</style>
